import * as React from "react";
import { Context } from "./types";

export const AppContext = React.createContext<Context>(null as any);
